/**
 * Mappa centrale stato datapoint → colore MUI Chip per il modulo data-capture.
 *
 * Fonte di verita' unica: prima di questo file la mappa era duplicata in 7
 * componenti con divergenze (es. `approved` blu in 5 file, verde in 2).
 *
 * Le label tradotte degli stati vivono in `i18n/config.ts` sotto
 * `dataCapture.status.*`. Qui restano solo le scelte di colore.
 */

export type StatusColor = 'default' | 'warning' | 'info' | 'success' | 'primary' | 'error';

export const STATUS_COLOR: Record<string, StatusColor> = {
  to_compile: 'default',
  draft: 'warning',
  in_validation: 'info',
  validated: 'success',
  approved: 'primary',
  consolidated: 'primary',
  consolidated_approved: 'success',
  validated_pending_consolidation: 'warning',
  admin_modified: 'error',
};

/** Colore del chip per uno stato; ricade su 'default' (grigio) se ignoto. */
export function getStatusColor(status: string | undefined | null): StatusColor {
  if (!status) return 'default';
  return STATUS_COLOR[status] ?? 'default';
}
